import { render, staticRenderFns } from "./chooseVideo.vue?vue&type=template&id=04f92e3f&scoped=true&"
import script from "./chooseVideo.vue?vue&type=script&lang=js&"
export * from "./chooseVideo.vue?vue&type=script&lang=js&"
import style0 from "./chooseVideo.vue?vue&type=style&index=0&id=04f92e3f&rel=stylesheet%2Fscss&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04f92e3f",
  null
  
)

export default component.exports